// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"798":"e8f53237","1656":"d10be74b"}[chunkId] + ".chunk.css";
};